import {
  SearchAlienationAutoriteFourriereFluxDto,
  SearchFluxAutoriteFourriereUsingGETQueryParamsSortDto,
} from 'lib_api/lib/api/gen';

import {
  TablePagination,
  TableSort,
} from 'components/WrappedComponents/Table/types';

import { FilterDashboardFlux } from '../../types';
import { SearchAlienationResponse } from '../shared/types';
import { useSearchFluxsAlienation } from '../shared/utils';

import { FluxAutoriteFourriereSortType } from './types';

export function useSearchFluxsAutoritesFourriere(
  _: FilterDashboardFlux,
  sorts: TableSort<FluxAutoriteFourriereSortType>,
  pagination: TablePagination,
): SearchAlienationResponse<SearchAlienationAutoriteFourriereFluxDto> {
  return useSearchFluxsAlienation<
    SearchAlienationAutoriteFourriereFluxDto,
    SearchFluxAutoriteFourriereUsingGETQueryParamsSortDto,
    FluxAutoriteFourriereSortType
  >(
    sorts,
    pagination,
    controller =>
      controller.searchFluxAutoriteFourriereUsingGET.bind(controller),
    sorts => {
      return {
        dateAppel: sorts?.DATE_APPEL,
      };
    },
  );
}
